import axios from 'axios';

export const flipmeConnectAsync = async ({
  emailCode,
  twoFACode
}: {
  emailCode: string;
  twoFACode: string;
}) => {
  const { data } = await axios.post(`/flipme/connect/confirm`, {
    emailCode,
    twoFACode
  });

  return data;
};

export const flipmeGetInfoAsync = async () => {
  const { data } = await axios.get(`flipme/status`);

  return data;
};

export const flipmeNFTWithdrawAsync = async ({
  userPackageId
}: {
  userPackageId: number;
}) => {
  const { data } = await axios.post(`flipme/nft-withdraw`, {
    userPackageId
  });

  return data;
};

export const flipmeBonusHubNFTWithdrawAsync = async () => {
  const { data } = await axios.post(`flipme/bonus-nft-withdraw`);

  return data;
};

export const redeemFlipmeCardAsync = async ({
  userPackageId,
  walletAddress
}: {
  userPackageId: number | null | undefined;
  walletAddress: string;
}) => {
  const { data } = await axios.post(`/flipme/card/user-package/redeem`, {
    userPackageId,
    walletAddress
  });

  return data.data as any;
};

export const checkRedeemAvailabilityAsync = async () => {
  const { data } = await axios.get(
    `flipme/card/rank-reward/redeem-availability`
  );

  return data;
};

export const redeemFlipmeCardInRankAsync = async () => {
  const { data } = await axios.post(`/flipme/card/rank-reward/redeem`);

  return data.data as any;
};

export const flipMeRankRewardsAsync = async () => {
  const { data } = await axios.get(`flipme/card/rank-reward`);

  return data;
};
